import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { App, ModalController, LoadingController } from 'ionic-angular';

import { UserService } from "./user/user-service";
import { EntityService } from "./entity/entity-service";
import { HttpService } from "./http/http-service";
import { CalculationService } from './calculation/calculation-service';
import { RowActionService } from './row-action/row-action-service';
import { UserManagementService } from './user-managment/user-management-service';
import { AccountingService } from './accounting/accounting-service';
import { HistoryService } from './history/history-service';

export { 
    UserService ,
    EntityService ,
    CalculationService ,
    HttpService ,
    RowActionService ,
    UserManagementService ,
    AccountingService ,
    HistoryService
};

export function provideUserService(httpService:HttpService, storage:Storage) : UserService {
    return new UserService(httpService, storage);
};

export function provideEntityService(httpService:HttpService, storage:Storage) : EntityService {
    return new EntityService(httpService, storage);
};

export function provideCalculationService(httpService:HttpService) : CalculationService {
    return new CalculationService(httpService);
};

export function provideHttpService(http:Http, storage:Storage, app:App) : HttpService {
    return new HttpService(http, storage, app);
}

export function provideRowActionService(calculationService:CalculationService, modalController:ModalController, loadingController:LoadingController) : RowActionService {
    return new RowActionService(calculationService, modalController, loadingController);
}

export function provideUserManagementService(httpService:HttpService) {
    return new UserManagementService(httpService);
}

export function provideAccountingService(httpService:HttpService) {
    return new AccountingService(httpService);
}

export function provideHistoryService(httpService:HttpService) {
    return new HistoryService(httpService);
}



// WEBPACK FOOTER //
// ./src/services/index.ts